<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
var _ = require('lodash');

export default {
  name: 'ReportMixin',
  computed: {
    ...mapGetters([
      'jwtAccess',
      'jwtAccessValid'
    ]),

    levelRange() {
      const vm = this
      let level = 1
      vm.reportFields.forEach(field => {
        if ('colspanNum' in field && field.colspanNum.length > level) {
          level = field.colspanNum.length
        } 
      })
      return _.range(level).reverse()
    },

    reportDataIsActual() {
      const vm = this
      let status = true
      if (vm.reportData.length > 0) {
        status = (vm.reportData[0].date == vm.reportDate) ? true : false
      }
      return status
    },
  },

  methods: {
    colspanFields(level) {
      const vm = this
        let thFields = []
        let colIndex = -1
        vm.reportFields.forEach(function(field, index){
          if ('colspanNum' in field && field.colspanNum[level] > 0) {
            colIndex = field.colspanNum[level] + index - 1
            thFields.push(field)
          } else if ((colIndex < index) && !('colspan' in field)){
            thFields.push(field)
          }
        })
        return thFields
    },
    colSum(key) {
      const vm = this
      return vm.numFormatter(vm.reportData.reduce((a, b) => Number(a) + Number(b[key] || 0), 0))
    },

    colSumTotal(key1, key2) {
      const vm = this
      let key1Sum = vm.reportData.reduce((a, b) => Number(a) + Number(b[key1] || 0), 0)
      let key2Sum = vm.reportData.reduce((a, b) => Number(a) + Number(b[key2] || 0), 0)
      return vm.numFormatter(key1Sum + key2Sum)
    },

    dateFormatter(value) {
      let y = value.slice(0, 4)
      let m = value.slice(5, 7)
      let d = value.slice(8, 10)
      return `${d}.${m}.${y}`
    },

    numFormatter(value) {
      let result = Number(value) == 0 ? '' : Number(value).toLocaleString()
      return result
    },

    colspanSumTotal(fieldObj){
      const vm = this
      let fieldIndex = vm.reportFields.findIndex(field => field.key == fieldObj.key)
      let fieldsToSum = vm.reportFields.filter((field, index) => {
        return (index >= fieldIndex) && (index <= fieldObj.colspanNum[0] + fieldIndex -1) && ('total' in fieldObj) && (fieldObj.total)
      })
      let total = 0
      fieldsToSum.forEach((field) => {
        total = total + vm.reportData.reduce((a, b) => Number(a) + Number(b[field.key] || 0), 0)
      })    
      return vm.numFormatter(total)
    },

  },

}
</script>

<style>

</style>